export enum AccountRole {
  User = 0,
  Admin = 10
}
